// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { differenceInWeeks as fn } from "../differenceInWeeks.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const differenceInWeeksWithOptions = convertToFP(fn, 3);

// Fallback for modularized imports:
export default differenceInWeeksWithOptions;
